import * as React from "react";
import type { SVGProps } from "react";
const SvgTargetBoard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2c1.153 0 2.278.195 3.352.575a2.707 2.707 0 0 1 3.962.692.996.996 0 0 1 1.407 1.412 2.707 2.707 0 0 1 .705 3.968A10 10 0 0 1 22 12c0 5.51-4.49 10-10 10m0-18.01a8 8 0 0 1 2.336.345 3 3 0 0 0-.026.375v2.298A5.5 5.5 0 0 0 12 6.5 5.51 5.51 0 0 0 6.5 12c0 3.03 2.47 5.5 5.5 5.5v.01a5.51 5.51 0 0 0 4.985-7.83h2.305v.01q.185 0 .365-.024C19.886 10.418 20 11.2 20 12c0 4.41-3.59 8-8 8s-8-3.59-8-8 3.59-8 8-8.01m1.67 4.928L11.29 11.3a.996.996 0 0 0 0 1.41c.2.19.45.29.71.29s.51-.09.71-.29l2.37-2.376A3.504 3.504 0 0 1 12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5c.592 0 1.159.141 1.67.418m4.057-1.238h1.563c.39 0 .71-.32.71-.71s-.32-.71-.71-.71h-.146zm-.007-2.818L16.3 6.284V4.69c0-.39.32-.71.71-.71s.71.32.71.71z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTargetBoard;
